import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgCalendar1YIcon = function SvgCalendar1YIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 169 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.6393 140.5H59.0142V92.1667L48.4807 101.342L44 95.8531L59.8003 82.5H66.6393V140.5Z",
    fill: "#D2D2D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M109.169 140.5H101.308V115.432L80.4766 82.5H90.0668L105.474 108.715L120.96 82.5H130L109.169 115.432V140.5Z",
    fill: "#D2D2D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.6411 141.5H58.0161V94.3639L48.3608 102.774L42.6055 95.7239L59.4362 81.5H67.6411V141.5ZM59.0161 92.1667V140.5H66.6411V82.5H59.8022L44.0018 95.8531L48.4825 101.342L59.0161 92.1667ZM110.171 141.5H100.31V115.722L78.6626 81.5H90.6409L105.478 106.745L120.391 81.5H131.818L110.171 115.722V141.5ZM120.962 82.5H130.002L109.171 115.432V140.5H101.31V115.432L80.4784 82.5H90.0687L105.476 108.715L120.962 82.5Z",
    fill: "#D2D2D9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5 5.5C40.5 2.46243 38.0376 0 35 0C31.9624 0 29.5 2.46243 29.5 5.5V16.5H20C8.95431 16.5 0 25.4543 0 36.5V149.5C0 160.546 8.9543 169.5 20 169.5H149C160.046 169.5 169 160.546 169 149.5V36.5C169 25.4543 160.046 16.5 149 16.5H139.5V5.5C139.5 2.46243 137.038 0 134 0C130.962 0 128.5 2.46243 128.5 5.5V16.5H40.5V5.5ZM128.5 27.5H40.5V31.5C40.5 34.5376 38.0376 37 35 37C31.9624 37 29.5 34.5376 29.5 31.5V27.5H20C15.0294 27.5 11 31.5294 11 36.5V56H158V36.5C158 31.5294 153.971 27.5 149 27.5H139.5V31.5C139.5 34.5376 137.038 37 134 37C130.962 37 128.5 34.5376 128.5 31.5V27.5ZM11 67H158V149.5C158 154.471 153.971 158.5 149 158.5H20C15.0294 158.5 11 154.471 11 149.5V67Z",
    fill: "#C6C6C6",
    fillOpacity: 0.4
  })));
};

export { SvgCalendar1YIcon as ReactComponent };
